export const CONSULTAR = "C";
export const INSERTAR = "I";
export const EDITAR = "E";
export const CANCELAR = "C";
export const OCULTAR = "O";
